module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Swag.043026bf.png";